import React from "react";
import { TRModal } from "../../../../components/Modal/TRModal";
import { useWindowInnerWidth } from "../../../hooks/use-window-inner-width";
import { ContactlessModalContents } from "./ContactlessModal/ContactlessModalContents";

export function ContactlessModal({ hideModal, isOpen }) {
  const windowInnerWidth = useWindowInnerWidth();
  return (
    <TRModal
      isOpen={isOpen}
      onDismiss={hideModal}
      fullscreen={windowInnerWidth <= 1024}
      /**
       * If we do not pass a className prop, then react-modal will apply default
       * styling to the modal. We can disable that default styling by passing any
       * non-blank class name. See https://reactcommunity.org/react-modal/styles/
       */
      className="disable-react-modal-default-styles"
    >
      <ContactlessModalContents hideModal={hideModal} />
    </TRModal>
  );
}
